import React, { useCallback, useEffect, useState } from "react";
import Notiofication from "../../../components/Modal/Notification";
import HelpModal from "../../../components/Modal/HelpModal";
import Select from "react-select";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import KitchenCard from "../../../components/AdminCards/KitchenCard";

function Kitchen() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(false);

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/kitchen`, {
        params: {
          outletId: user?.user?.outlet_id,
          orderStatus: "new",
          approvalStatus: "approved",
        },
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setOrders(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message || "Some error occured");
      });
  }, [user?.token, user?.user?.outlet_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (error) return <MessageCard error={error} />;

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between py-3">
          <div>
            <h1 className="text-d-bg-text text-2xl">Kitchen</h1>
          </div>
          <div className="flex gap-3">
            <div>
              <Select
                type="text"
                placeholder="Select Item"
                className="   placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
              />
            </div>

            <Notiofication />
            <HelpModal />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {orders?.map((order, idx) => (
            <KitchenCard key={idx} order={order} fetchData={fetchData} />
          ))}
        </div>
        {/* <div className="w-64 h-96 border border-[#7B20C7] bg-white border-dashed m-4 rounded-md relative">
          <div className="w-full bg-[#7B20C7] text-white p-2 text-sm flex justify-between">
            <div>
              <span>
                <h5>Invoice: A 000351</h5>
                <h5>Table: None</h5>
              </span>
            </div>
            <div>
              <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded">
                10:04
              </span>
            </div>
          </div>
          <div className="flex flex-col justify-between h-80">
            <div className="p-2 text-sm h-64 overflow-y-auto">
              {orders.map((deal, idx) => (
                <div
                  key={idx}
                  className={`w-full flex justify-between my-2 p-2 relative ${
                    selectedDeals.includes(deal.id) ? "bg-blue-100" : ""
                  }`}
                >
                  <div>
                    <span>
                      <h5>Deal: {deal.id}</h5>
                      <h5 className="font-medium">QTY: {deal.quantity}</h5>
                    </span>
                  </div>
                  <div>
                    <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded">
                      Ready
                    </span>
                  </div>
                  <div className="absolute top-0 left-0 w-full h-full">
                    <input
                      type="checkbox"
                      name=""
                      id={deal.id}
                      className="w-full h-full opacity-0"
                      onClick={() => handleToggleSelect(deal.id)}
                      checked={selectedDeals.includes(deal.id)}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="p-2 text-xs relative left-0 border-t flex gap-2">
              <button onClick={handleSelectAll}>Select All</button>
              <button onClick={handleUnselectAll}>Unselect All</button>
            </div>
          </div>
        </div> */}
      </div>
    </main>
  );
}

export default Kitchen;
